import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerformanceIncrease = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "performance-increase" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 23.25,
			x2: 23.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,17.25H3a.75.75,0,0,0-.75.75v5.25h4.5V18A.75.75,0,0,0,6,17.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.5,12.75h-3a.75.75,0,0,0-.75.75v9.75h4.5V13.5A.75.75,0,0,0,13.5,12.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21,9.75H18a.75.75,0,0,0-.75.75V23.25h4.5V10.5A.75.75,0,0,0,21,9.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.182,
			y1: 9.241,
			x2: 20.25,
			y2: 1.944
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "19.056 5.126 20.25 1.944 17.068 0.75"
		})
	]
});
export default SvgPerformanceIncrease;
